import { render } from "./ContabilidadPage.vue?vue&type=template&id=1cf1e2ae"
import script from "./ContabilidadPage.vue?vue&type=script&lang=js"
export * from "./ContabilidadPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__